<svelte:options accessors/>
<script>
    import NauiSelect from "../../naui/atoms/NauiSelect.svelte";
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import NauiFieldsetTable from "../../naui/components/NauiFieldsetTable.svelte";
    import NauiFloatingAction from "../../naui/components/NauiFloatingAction.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    export let data = {
        site: undefined,
        toSite: undefined,
        type: undefined,
        description: undefined,
        pqrs: undefined
    }
    export let fieldsets = [];
    export let types = [];
    export let sites = [];
    export let titles = {};
    export let create = false;
    let label = 'Datos básicos';
    const dispatch = createEventDispatcher();

    function isValid() {
        let valid = ['site', 'type', 'description'].every(k => !!data[k]);
        const postData = {
            site: data.site,
            type: data.type,
            description: data.description
        }
        if (postData.type === 'salida-remision') {
            postData.toSite = data.toSite
        }
        const obj = fieldsets.reduce((acc, item) => {
            item.fields.forEach(f => {
                acc[f.slug] = f.value;
                valid = valid && (f.value !== null || f.value !== undefined)
            })
            return acc
        }, postData)
        return {
            valid: valid,
            data: obj
        }
    }

    function send(verb) {
        const {valid, data} = isValid()
        if (valid) {
            dispatch('send', {
                verb,
                data
            });
        } else {
            alert('Datos no validos')
        }
    }

</script>
<div class="mt-2">
    <div class="box-l sx-ii mb-2">
        <div class="w-300px">
            <NauiSelect label="Sede"
                        class="w-100"
                        bind:value={data.site}
                        options={sites||[]}/>
        </div>
        <div class="w-300px">
            <NauiSelect label="Tipo"
                        bind:value={data.type}
                        on:change={()=>label=titles[data.type]}
                        options={types || []}/>
        </div>
        <div class="w-300px">
            <NauiInput label="Descripción"
                       bind:value={data.description}/>
        </div>
        {#if data.type === 'salida-pqrs'}
            <div class="w-300px">
                <NauiInput label="PQRS"
                           bind:value={data.pqrs}/>
            </div>
        {/if}
    </div>
    {#if data.type === 'salida-remision'}
        <div class="box-l sx-ii mb-2">
            <div class="w-300px">
                <NauiSelect label="Sede en la que va a ingresar"
                            bind:value={data.toSite}
                            options={sites || []}/>
            </div>
        </div>
    {/if}
    <div>
        <hr class="w-100 mb-2">
        <div class="max-w-600px">
            {#each fieldsets as fieldset}
                <NauiFieldsetTable title={label}
                                   fields={fieldset.fields}/>
            {/each}
        </div>
    </div>
</div>

<NauiFloatingAction>
    {#if create}
        <NauiButton caption="GUARDAR"
                    icon="save"
                    color="accent"
                    mode="solid"
                    type="submit"
                    on:click={()=>send('POST')}/>
    {:else}
        <!--
        <NauiButton caption="ACTUALIZAR"
                    icon="save"
                    color="accent"
                    mode="solid"
                    type="submit"
                    on:click={()=>send('PATCH')}/>
        -->
    {/if}
</NauiFloatingAction>
<style>
    .w-300px {
        width: 300px;
    }
</style>